(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-row"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.railnav').forEach((nav) => {
    const section = nav.closest('.section');
    const rail = section.querySelector('[data-rail]');
    if (!rail) return;

    const step = () => {
      const first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return (first.getBoundingClientRect().width + gap) * 2;
    };

    const prev = nav.querySelector('[data-rail-prev]');
    const next = nav.querySelector('[data-rail-next]');

    let target = 0;

    const clamp = (v) => Math.max(0, Math.min(v, rail.scrollWidth - rail.clientWidth));

    const move = (dir) => {
      target = clamp(target + dir * step());
      rail.scrollLeft = target;
      sync();
    };

    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    function sync() {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = target <= 2;
      next.disabled = target >= max;
    }

    let settle;
    rail.addEventListener('scroll', () => {
      clearTimeout(settle);
      settle = setTimeout(() => { target = rail.scrollLeft; sync(); }, 180);
    }, { passive: true });

    window.addEventListener('resize', () => { target = clamp(target); sync(); });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('.hdr');
  if (header) {
    const burger = header.querySelector('.hdr__burger');
    const panel = header.querySelector('.hdr__mobile');
    burger?.addEventListener('click', () => {
      const open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach((root) => {
    const track = root.querySelector('[data-hero-track]');
    const slides = Array.from(track.children);
    if (!slides.length) return;
    if (slides.length < 2) {
      root.querySelectorAll('.hero__arrow').forEach((b) => b.remove());
    }

    const dotWrap = root.querySelector('[data-hero-dots]');
    const videos = Array.from(root.querySelectorAll('video'));
    const motion = root.querySelector('[data-hero-motion]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduce.matches;
    let index = 0;
    let timer = null;

    if (slides.length < 2) dotWrap.remove();
    else slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hero__dot';
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.addEventListener('click', () => go(i));
      dotWrap.appendChild(dot);
    });
    const dots = Array.from(dotWrap.children);

    function paint() {
      dots.forEach((d, i) => d.setAttribute('aria-pressed', String(i === index)));
    }

    function syncMotion() {
      clearInterval(timer);
      timer = null;
      const visible = document.visibilityState === 'visible';
      videos.forEach((v) => {
        if (!paused && visible && slides[index].contains(v)) {
          if (v.paused) {
            const r = v.play();
            if (r && r.catch) r.catch((error) => {
              if (error.name === 'NotAllowedError') {
                paused = true;
                syncMotion();
              }
            });
          }
        } else {
          v.pause();
        }
      });
      motion.setAttribute('aria-pressed', String(paused));
      motion.setAttribute('aria-label', paused ? motion.dataset.resumeLabel : motion.dataset.pauseLabel);
      motion.querySelector('[data-motion-pause]').toggleAttribute('hidden', paused);
      motion.querySelector('[data-motion-play]').toggleAttribute('hidden', !paused);
      if (slides.length > 1 && root.dataset.autoplay === 'true' && !paused && visible &&
          !root.matches(':hover') && !root.contains(document.activeElement)) {
        const ms = Number(root.dataset.interval) * 1000 || 6000;
        timer = setInterval(() => go(index + 1), ms);
      }
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
      paint();
      syncMotion();
    }

    root.querySelector('[data-hero-prev]')?.addEventListener('click', () => go(index - 1));
    root.querySelector('[data-hero-next]')?.addEventListener('click', () => go(index + 1));
    motion.hidden = !videos.length && (slides.length < 2 || root.dataset.autoplay !== 'true');
    motion.addEventListener('click', () => {
      paused = !paused;
      syncMotion();
    });
    reduce.addEventListener('change', (event) => {
      if (event.matches) paused = true;
      syncMotion();
    });

    paint();
    syncMotion();

    videos.forEach((v) => {
      v.muted = true;
      v.addEventListener('loadeddata', syncMotion, { once: true });
      v.addEventListener('canplay', syncMotion, { once: true });
    });
    document.addEventListener('visibilitychange', syncMotion);
    window.addEventListener('pageshow', syncMotion);
    root.addEventListener('mouseenter', syncMotion);
    root.addEventListener('mouseleave', syncMotion);
    root.addEventListener('focusin', syncMotion);
    root.addEventListener('focusout', () => requestAnimationFrame(syncMotion));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('filter-drawer');
    const scrim = document.querySelector('[data-filter-scrim]');
    const openBtn = document.querySelector('[data-filter-open]');
    if (!drawer || !openBtn) return;

    const setOpen = (on) => {
      drawer.classList.toggle('is-open', on);
      scrim.hidden = !on;
      openBtn.setAttribute('aria-expanded', String(on));
      document.body.style.overflow = on ? 'hidden' : '';
      if (on) drawer.querySelector('[data-filter-close]').focus();
      else openBtn.focus();
    };

    openBtn.addEventListener('click', () => setOpen(true));
    scrim.addEventListener('click', () => setOpen(false));
    drawer.querySelectorAll('[data-filter-close]').forEach((b) => b.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  })();

  document.querySelectorAll('[data-catnav]').forEach((el) => {
    const wide = window.matchMedia('(min-width: 900px)');
    const apply = () => { el.open = wide.matches; };
    apply();
    wide.addEventListener('change', apply);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const form = document.getElementById('product-form');
  if (form) {
    const select = form.querySelector('select[name="id"]');
    const radios = form.querySelectorAll('.pdp__radio');
    const priceBox = document.querySelector('[data-price]');
    const addBtn = form.querySelector('.pdp__add');
    const dataTag = document.querySelector('[data-variant-data]');

    let variants = [];
    try { variants = JSON.parse(dataTag.textContent).variants; } catch (e) { variants = []; }

    const paint = (id) => {
      const v = variants.find((x) => String(x.id) === String(id));
      if (!v || !priceBox) return;

      const cur = priceBox.querySelector('[data-current]');
      if (cur) cur.textContent = v.price;

      let cmp = priceBox.querySelector('[data-compare]');
      if (v.compare) {
        if (!cmp) {
          cmp = document.createElement('s');
          cmp.setAttribute('data-compare', '');
          priceBox.prepend(cmp);
        }
        cmp.textContent = v.compare;
        priceBox.classList.add('pdp__price--sale');
      } else {
        if (cmp) cmp.remove();
        priceBox.classList.remove('pdp__price--sale');
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      }
    };

    const sync = () => {
      const chosen = Array.from(form.querySelectorAll('.pdp__radio:checked')).map((r) => r.value).join(' / ');
      const match = Array.from(select.options).find((o) => o.text === chosen);
      if (match) {
        select.value = match.value;
        paint(match.value);
      }
    };

    radios.forEach((r) => r.addEventListener('change', sync));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = () => {
      document.querySelectorAll('.pbanner__video').forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.playsInline = true;

        const tryPlay = () => {
          const r = v.play();
          if (r && r.catch) r.catch(() => {});
        };

        tryPlay();
        v.addEventListener('canplay', tryPlay, { once: true });
        v.addEventListener('loadeddata', tryPlay, { once: true });

        let inView = true;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            inView = e.isIntersecting;
            if (inView) tryPlay();
            else v.pause();
          });
        }, { threshold: 0.15 });
        io.observe(v);

        v.addEventListener('pause', () => {
          if (v.ended) return;
          if (document.visibilityState === 'visible' && inView) {
            requestAnimationFrame(tryPlay);
          }
        });

        const resume = () => {
          if (document.visibilityState === 'visible' && v.paused) tryPlay();
        };
        document.addEventListener('visibilitychange', resume);
        window.addEventListener('pageshow', resume);

        const onGesture = () => {
          if (v.paused) tryPlay();
        };
        ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((ev) =>
          window.addEventListener(ev, onGesture, { once: true, passive: true })
        );
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
